import React, { useEffect } from 'react';
import { isIOS, isAndroid } from 'react-device-detect';
import { useLocation, Link } from 'react-router-dom';
import mobileLogo from '../assets/images/images_new/mobile-logo-la.svg';
import appleIcon from '../assets/images/images_new/apple-icon.svg';
import playStoreIcon from '../assets/images/images_new/play-store-icon.svg';
import '../assets/css/download-button.css';

const AppDownloadRedirect = () => {
    const location = useLocation();
    
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const rawAppType = queryParams.get('app');
        const appType = rawAppType === 'naati' ? 'naati' : 'pte';

        // Fallback URLs in case environment variables are missing
        const fallbacks = {
            pte: {
                ios: 'https://apps.apple.com/in/app/la-pte/id6443614190',
                android: 'https://play.google.com/store/search?q=language+academy&c=apps&hl=en_IN'
            },
            naati: {
                ios: 'https://apps.apple.com/au/app/la-ccl/id1536541464',
                android: 'https://play.google.com/store/apps/details?id=com.languageacademy.naati'
            }
        };

        const getSafeEnv = (key) => {
            const val = import.meta.env[key];
            return (val && val !== "undefined" && val !== "null") ? val : null;
        };

        const appleStoreUrl = (appType === 'naati' 
            ? getSafeEnv('VITE_NAATI_IOS_APP_URL') 
            : getSafeEnv('VITE_PTE_IOS_APP_URL')) || fallbacks[appType].ios;
            
        const googlePlayUrl = (appType === 'naati' 
            ? getSafeEnv('VITE_NAATI_ANDROID_APP_URL') 
            : getSafeEnv('VITE_PTE_ANDROID_APP_URL')) || fallbacks[appType].android;

        const timer = setTimeout(() => {
            if (isIOS && appleStoreUrl && appleStoreUrl !== "undefined") {
                window.location.href = appleStoreUrl;
            } else if (isAndroid && googlePlayUrl && googlePlayUrl !== "undefined") {
                window.location.href = googlePlayUrl;
            }
        }, 3000); // 3 second delay to show the professional splash screen

        return () => clearTimeout(timer);
    }, [location]);

    const queryParams = new URLSearchParams(location.search);
    const appType = queryParams.get('app') || 'pte';
    
    const fallbacks = {
        pte: {
            ios: 'https://apps.apple.com/in/app/la-pte/id6443614190',
            android: 'https://play.google.com/store/search?q=language+academy&c=apps&hl=en_IN'
        },
        naati: {
            ios: 'https://apps.apple.com/au/app/la-ccl/id1536541464',
            android: 'https://play.google.com/store/apps/details?id=com.languageacademy.naati'
        }
    };

    const getSafeEnv = (key) => {
        const val = import.meta.env[key];
        return (val && val !== "undefined" && val !== "null") ? val : null;
    };

    const appleStoreUrl = (appType === 'naati' 
        ? getSafeEnv('VITE_NAATI_IOS_APP_URL') 
        : getSafeEnv('VITE_PTE_IOS_APP_URL')) || fallbacks[appType].ios;
        
    const googlePlayUrl = (appType === 'naati' 
        ? getSafeEnv('VITE_NAATI_ANDROID_APP_URL') 
        : getSafeEnv('VITE_PTE_ANDROID_APP_URL')) || fallbacks[appType].android;

    return (
        <div className="redirect-container">
            <div className="redirect-content">
                <Link to="/" className="redirect-logo-link">
                    <img src={mobileLogo} alt="Language Academy" className="redirect-logo" />
                </Link>
                
                <div className="spinner-container">
                    <div className="spinner-dots">
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                        <div className="redirect-dot"></div>
                    </div>
                </div>

                <h1 className="redirect-title">Please Wait...</h1>
                <p className="redirect-subtitle">You are being redirected to the App Store.</p>

                <div className="redirect-footer-section">
                    <p className="redirect-footer-text">If you are not redirected automatically, please click below</p>
                    
                    <div className="redirect-button-container">
                        <a href={googlePlayUrl} className="store-badge">
                            <img src={playStoreIcon} alt="Google Play" className="badge-icon" />
                            <div className="badge-text-wrapper">
                                <span className="badge-small-text">GET IT ON</span>
                                <span className="badge-large-text">Google Play</span>
                            </div>
                        </a>
                        
                        <a href={appleStoreUrl} className="store-badge">
                            <img src={appleIcon} alt="App Store" className="badge-icon" />
                            <div className="badge-text-wrapper">
                                <span className="badge-small-text">Download on the</span>
                                <span className="badge-large-text">App Store</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppDownloadRedirect;
